/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import axios from 'axios';
import {getResourceSuccess, resourceUpload} from '../_actions/resource.upload.actions';
import {fetchApiDataFailure} from "../_actions/common.actions";
import api from "./api.services";
import {getCollectionById} from "./collection.thunk";
import {hideModal} from "../_actions/modal.actions";
import {showMessage} from "../_actions/message.actions";

export const uploadFile = (params, formData) => dispatch => {
    const url = api.upload.replace('{collection-id}', params.collectionId)
        +"?orientation=" +params.orientation+"&collectionType="+params.collectionType+"&unscrubbed="+params.unscrubbed;
    axios.post(url, formData)
        .then((response) => {
            dispatch(resourceUpload(response));
        })
        .catch(error => {
            dispatch(showMessage({messageKey: 'upload_pdf_error', type: 'error' }));
            dispatch(fetchApiDataFailure(error));
        });
};

export const updateAdditionalResourceInfo = (options, requestBody) => dispatch => {
    const resourceId = options.resourceId;
    const collectionId = options.collectionId;

    axios.post(api.update_additional_info.replace('{resource-id}', resourceId), requestBody)
        .then(response => {
            dispatch(getCollectionById(collectionId));
            dispatch(hideModal());
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const getResourceDetails = (options) => dispatch => {
    axios.get(api.get_resource_by_id.replace('{resource-id}', options.resourceId)
        .replace('{priceType}', options.priceType)
        .replace('{currency}', options.currency))
        .then(response => {
            dispatch(getResourceSuccess(response));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/upload.thunk.js